import dynamic from 'next/dynamic'

export const BentoRectangleFourParts = dynamic(
    () => import('./bento-rectangle-four-parts'),
)
